<template>
    <v-dialog v-model="show" max-width="400" persistent no-click-animation>
        <div class="ConfirmDeleteDialog">
            <!--Header dialog-->
            <div class="dialog-header" v-if="title && title !== ''">
                <div>{{title}}</div>
                <v-btn small icon @click="disagree">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </div>
            <!--Content dialog-->
            <div class="dialog-content">
                {{$f.tc('confirmDeleteItem')}} {{$t(moduleName)}}: {{ name }}?
                
                <div class="mt-6" style="font-size: 13px; font-style: italic; color: red">
                    <strong>*{{ $f.tc('notice') }}</strong>:
                    {{ $t('deleteCustomerNotice', { nameTab: $f.tc('output') }) }}
                </div>
            </div>
            <!--Dialog footer-->
            <div class="dialog-footer">
                <div class="btn-danger mr-8" @click="agree">{{ $f.tc('delete') }}</div>
                <div class="btn-outline" @click="disagree">{{ $f.tc('cancel') }}</div>
            </div>
        </div>
    </v-dialog>
</template>
<script>
export default {
    name   : 'ConfirmDeleteDialog',
    props  : {
        title: {
            type   : String,
            default: ''
        }
    },
    data() {
        return {
            show      : false,
            moduleName: '',
            name      : ''
        }
    },
    methods: {
        disagree() {
            this.$emit('disagree')
            this.show = false
        },
        agree() {
            this.$emit('agree')
            this.show = false
        },
        open(moduleName, name) {
            this.moduleName = moduleName
            this.name       = name
            this.show       = true
        }
    }
}
</script>
<style lang="scss" scoped>
.ConfirmDeleteDialog {
    background: #FFFFFF;
    border-radius: 5px !important;
    overflow: hidden;

    .btn-custom {
        margin-right: 8px;
    }
}
</style>
